module.exports = __webpack_public_path__ + "img/caitiao.c9dd27a9.svg";